import { Component, ViewEncapsulation, QueryList, ViewChildren, AfterViewInit, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { TranslationStringComponent } from '@portal-core/i18n/components/translation-string/translation-string.component';
import { CommonString } from '@portal-core/i18n/enums/common-string.enum';

@Component({
  selector: 'mc-common-strings',
  templateUrl: './common-strings.component.html',
  styleUrls: ['./common-strings.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonStringsComponent implements AfterViewInit {
  @Output() ready: EventEmitter<any> = new EventEmitter<any>();
  @ViewChildren(TranslationStringComponent) commonTranslationStrings: QueryList<TranslationStringComponent>;

  commonStrings: Dictionary<string>;
  CommonString: typeof CommonString = CommonString;

  ngAfterViewInit() {
    const commonStrings: Dictionary<string> = {};

    this.commonTranslationStrings.forEach(translationString => {
      commonStrings[translationString.name] = translationString.text;
    });

    this.commonStrings = commonStrings;
    this.ready.emit(this.commonStrings);
  }
}
